import { useQuery } from '@tanstack/react-query';
import {
    fetchProductSubscriptionPeriodsV2,
    SubscriptionPeriodPricesContainerOut
} from './fetchProductSubscriptionPeriodsV2';
import { GlobalReactQueryOptions } from '../../config';
import { browserClient } from '../../react-query';

const CACHE_KEY = 'subscriptionStartOptionsV2';

export const useProductSubscriptionPeriodsV2 = (productId: string) => {
    return useQuery<SubscriptionPeriodPricesContainerOut>(
        [CACHE_KEY, productId],
        () => fetchProductSubscriptionPeriodsV2(productId),
        { ...GlobalReactQueryOptions }
    );
};

export const invalidateSubscriptionStartPeriods = (productId: string) => {
    return browserClient.invalidateQueries([CACHE_KEY, productId]);
};
